<template>
  <div>
    <div v-show="value" :style="{height: `${height}px`}" class="p-5">
      <div class="d-flex justify-content-center">
        <b-spinner
          variant="info"
          label="Betöltés"
          :style="{width: '5rem', height: '5rem', 'margin-top': `calc((${height}px - 18rem) / 2)`}"
        />
      </div>
      <div class="d-flex justify-content-center mt-4">
        <strong>Betöltés folyamatban...</strong>
      </div>
    </div>
    <slot v-if="!value"></slot>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      height: {
        type: Number,
        default: 400
      }
    }
  }
</script>